import _parse from "./parse";
import _stringify from "./stringify";
var exports = {};
const parse = _parse;
const stringify = _stringify;
const JSON5 = {
  parse,
  stringify
};
exports = JSON5;
export default exports;